module.exports = __webpack_public_path__ + "static/media/spinner-third.ab1ec528.svg";